import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  constructor(
    private authService: AuthService,
    private keycloak: Keycloak,
    private router: Router
  ) {}

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (
      event.shiftKey &&
      event.ctrlKey &&
      event.code === 'KeyU' &&
      environment.name === 'staging'
    ) {
      throw new Error('Fake Error caused by hotkeys');
    }
  }

  ngOnInit() {
    const redirectUrl = this.authService.consumeRedirectedUrl();

    if (redirectUrl && this.keycloak.authenticated) {
      this.router.navigateByUrl(redirectUrl);
    }
  }
}
